<div class="h-screen overflow-auto lg:pl-16 py-8  grid md:grid-cols-2">
  <!-- left side -->
  <div class="sticky hidden md:flex flex-col rounded-tl-3xl overflow-hidden ">
    <img
      [src]="slides[currentIndex]?.image"
      alt="Feature Image"
      class="absolute top-0 left-0 z-0 w-full h-full object-cover transition-all duration-700 ease-in-out"
    />

    <div
      class="absolute z-10 top-0 left-0 w-full h-full bg-gradient-to-b from-black/10 via-black/50 to-black/75"
    ></div>

    <div class="relative z-20 w-full grid grid-cols-2">
      <div class="rounded-tl-3xl relative">
        <div class="absolute top-0 right-0 notched-top-right"></div>
      </div>
      <div class="rounded-bl-3xl bg-white flex pl-3">
        <p
          class="text-primary text-sm font-medium hidden lg:flex items-center justify-center gap-2 rounded-full border border-primary ml-4 w-[96%] px-4 py-4 mx-auto"
        >
          <i class="fas fa-newspaper text-[#1A4A9C]"></i>
          <span>Digital Publishing Management System</span>
        </p>
      </div>
    </div>
    <div class="relative z-20 flex-1 col-span-full w-full flex flex-col px-16">
      <div class="absolute top-0 right-0 notched-top-right"></div>
      <div class="absolute bottom-0 left-0 notched-bottom-left"></div>
      <div class="absolute bottom-0 right-0 notched-bottom-right"></div>

      <div class="flex flex-col mt-auto mb-[2%]">
        <div
          class="text-2xl font-sans text-white mt-auto py-8 text-left w-[60%]"
        >
          {{ slides[currentIndex]?.text }}
        </div>
        <!-- Features List -->
        <div class="space-y-2 mb-6">
          <div class="flex items-center gap-3 text-sm text-white">
            <div
              class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0"
            >
              <i class="fas fa-check text-blue-600 text-xs"></i>
            </div>
            <span>Manage newspapers & magazines</span>
          </div>
          <div class="flex items-center gap-3 text-sm text-white">
            <div
              class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0"
            >
              <i class="fas fa-check text-blue-600 text-xs"></i>
            </div>
            <span>Digital book library system</span>
          </div>
          <div class="flex items-center gap-3 text-sm text-white">
            <div
              class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0"
            >
              <i class="fas fa-check text-blue-600 text-xs"></i>
            </div>
            <span>Real-time publishing tools</span>
          </div>
        </div>
      </div>
    </div>

    <!-- lower action buttons -->
    <div class="w-full flex relative z-20">
      <div class="absolute top-0 left-0 notched-top-left"></div>
      <div class="absolute bottom-0 right-0 notched-bottom-right"></div>
      <div class="absolute top-0 right-0 notched-top-right"></div>
      <div class="rounded-tr-3xl pt-3 pb-2 pr-3 bg-white">
        <button
          (click)="prev()"
          class="w-16 h-fit aspect-square p-2 rounded-xl bg-primary/20 hover:bg-primary/40 transition-all duration-100 ease-in text-primary"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
      <div class="flex-1 h-full relative flex justify-center">
        <div class="absolute bottom-0 right-0 notched-bottom-right"></div>
        <div class="absolute bottom-0 left-0 notched-bottom-left"></div>
        <div class="flex space-x-3 mt-8">
          <div
            *ngFor="let slide of slides; let i = index"
            class="cursor-pointer transition-all duration-300 rounded-full !h-3"
            [ngClass]="{
              'w-8  bg-primary-200 ': i === currentIndex,
              'w-3  bg-white  hover:bg-white/80': i !== currentIndex
            }"
          ></div>
        </div>
      </div>
      <div class="rounded-tl-3xl pt-3 pb-2 pl-3 bg-white">
        <button
          (click)="next()"
          class="w-16 h-fit aspect-square p-2 rounded-xl bg-primary/20 hover:bg-primary/40 transition-all duration-100 ease-in text-primary"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- right-side -->
  <div class="relative h-full overflow-auto scroll-m-0">
  
    <!-- Floating Icons for ePaper Theme -->
    <div
      class="absolute top-36 left-20 text-[#03406C]/10 text-3xl animate-float"
    >
      <i class="fas fa-newspaper"></i>
    </div>
    <div
      class="absolute top-40 right-32 text-[#03406C]/10 text-3xl animate-float-delayed"
    >
      <i class="fas fa-book-open"></i>
    </div>
    <div
      class="absolute bottom-32 left-40 text-[#03406C]/10 text-4xl animate-float"
    >
      <i class="fas fa-scroll"></i>
    </div>
    <div
      class="absolute bottom-20 right-20 text-[#03406C]/10 text-3xl animate-float-delayed"
    >
      <i class="fas fa-feather-alt"></i>
    </div>

    <!-- Main Content Container -->

    <div class="relative z-20 flex flex-col justify-center items-center h-fit lg:ml-16 ">
      <div class="w-full max-w-7xl flex justify-end mb-8 h-fit">
          <button
            (click)="goBack()"
            class="flex items-center gap-3 mr-2 px-6 py-3 rounded-2xl bg-white/90 backdrop-blur-lg shadow-lg hover:shadow-xl hover:bg-white transition-all duration-300 group border border-gray-200"
          >
            <mat-icon class="text-2xl text-[#1A4A9C] group-hover:scale-110 transition-transform">home</mat-icon>
            <span class="font-semibold text-[#1A4A9C] hidden sm:inline">Home</span>
          </button>
    </div>
      
      <!-- Logo & Emblem Section -->
      <div class="flex justify-center items-center gap-4 animate-fadeIn w-full">
        <img src="assets/images/tsn.png" class="w-16 h-16" alt="tsn Emblem" />
      </div>

      <!-- Login Form -->
      <div class="w-full animate-slideUp">
        <div class="max-w-lg mx-auto backdrop-blur-md p-8">
          

          <!-- Title -->
          <div class="mb-6 text-center">
                       <h2 class="!text-4xl !font-semibold text-[#1A4A9C] !my-0 mb-1">
Welcome Back</h2>
            <p class="text-lg text-gray-500">
              {{ loginMode === 'PASSWORD' ? 'Sign in with email & password' : 'Sign in with phone number' }}
            </p>
          </div>

          <!-- ================= PASSWORD LOGIN ================= -->
          <form
            *ngIf="loginMode === 'PASSWORD'"
            [formGroup]="form"
            (ngSubmit)="login(form.value)"
            autocomplete="off"
            novalidate
          >
            <!-- Email -->
            <div class="mb-5">
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                formControlName="username"
                class="w-full h-14 rounded-xl border px-4"
                placeholder="Enter email"
              />
            </div>

            <!-- Password -->
            <div class="mb-6">
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                Password
              </label>
              <div class="relative">
                <input
                  [type]="hide ? 'password' : 'text'"
                  formControlName="password"
                  class="w-full h-14 rounded-xl border px-4 pr-12"
                  placeholder="Enter password"
                />
                <button
                  type="button"
                  class="absolute right-3 top-1/2 -translate-y-1/2"
                  (click)="hide = !hide"
                >
                  <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </div>
            </div>

            <!-- Remember Me & Forgot Password -->
          <div class="flex items-center justify-between mb-6">
            <label class="flex items-center cursor-pointer">
              <input
                type="checkbox"
                class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-[#1A4A9C]"
              />
              <span class="ml-2 text-sm text-gray-600">Remember me</span>
            </label>
            <a
              routerLink="/forgot-password"
              class="text-sm text-[#124B99] font-semibold hover:text-[#509EE3] transition-colors"
            >
              Forgot Password?
            </a>
          </div>


            <!-- Submit Button -->
            <button
              type="submit"
              [disabled]="loading || form.invalid"
              class="w-full h-14 rounded-xl bg-[#1A4A9C] text-white font-bold mt-4"
            >
              <span *ngIf="!loading">Sign In</span>
              <span *ngIf="loading">Please wait...</span>
            </button>
          </form>

          <!-- ================= OTP LOGIN ================= -->
          <div *ngIf="loginMode === 'OTP'" [formGroup]="form">
            
            <!-- Phone Number Input (shown when OTP not sent) -->
            <div class="mb-5" *ngIf="!otpSent">
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                Phone Number
              </label>
              <input
                type="tel"
                formControlName="phoneNumber"
                class="w-full h-14 rounded-xl border px-4"
                placeholder="e.g 712345678"
              />
              <p class="text-xs text-gray-500 mt-1">Enter your phone number without country code</p>
            </div>

            <!-- Send OTP Button -->
            <button
              *ngIf="!otpSent"
              type="button"
              (click)="generateOtp()"
              [disabled]="loading || form.get('phoneNumber')?.invalid"
              class="w-full h-14 rounded-xl bg-[#1A4A9C] text-white font-bold mt-4"
            >
              <span *ngIf="!loading">Send OTP</span>
              <span *ngIf="loading">Sending...</span>
            </button>

            <!-- OTP Input (shown after OTP is sent) -->
            <div *ngIf="otpSent">
              <div class="mb-5">
                <label class="block text-sm font-semibold text-gray-700 mb-2">
                  Enter OTP
                </label>
                <input
                  type="text"
                  formControlName="otp"
                  class="w-full h-14 rounded-xl border px-4 text-center text-2xl tracking-widest"
                  placeholder="000000"
                  maxlength="6"
                />
                <p class="text-xs text-gray-500 mt-1">
                  OTP sent to {{ savedPhoneNumber }}
                  <button
                    type="button"
                    (click)="resetOtpFlow()"
                    class="text-[#1A4A9C] font-semibold ml-2"
                  >
                    Change number
                  </button>
                </p>
              </div>

              <!-- Verify OTP Button -->
              <button
                type="button"
                (click)="verifyOtpAndLogin()"
                [disabled]="loading || form.get('otp')?.invalid"
                class="w-full h-14 rounded-xl bg-[#1A4A9C] text-white font-bold mt-4"
              >
                <span *ngIf="!loading">Verify OTP</span>
                <span *ngIf="loading">Verifying...</span>
              </button>

              <!-- Resend OTP -->
              <div class="text-center mt-3">
                <button
                  type="button"
                  (click)="generateOtp()"
                  [disabled]="loading"
                  class="text-sm text-[#1A4A9C] font-semibold hover:underline"
                >
                  Resend OTP
                </button>
              </div>
            </div>

          </div>


          <!-- ================= SWITCH MODE ================= -->
          <div class="text-center mt-4">
            <button
              type="button"
              class="text-sm text-gray-300 font-semibold hover:textyellow"
              (click)="networkLogin()"
            >
              {{  'Continue with Network Login'
                 }}
            </button>
          </div>



          <!-- ================= SWITCH MODE ================= -->
          <div class="text-center mt-4">
            <button
              type="button"
              class="text-sm text-[#1A4A9C] font-semibold"
              (click)="loginMode === 'PASSWORD' ? enableOtpLogin() : enablePasswordLogin()"
            >
              {{ loginMode === 'PASSWORD'
                ? 'Continue with phone number'
                : 'Use email & password instead' }}
            </button>
          </div>


          

          <!-- ================= GOOGLE ================= -->
          <div class="mt-6">
            <div class="relative mb-4">
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-300"></div>
              </div>
              <div class="relative flex justify-center text-sm">
                <span class="px-2 bg-white text-gray-500">Or continue with</span>
              </div>
            </div>

            <button
              type="button"
              (click)="onGoogleSocialLogin()"
              [disabled]="loading"
              class="w-full h-14 rounded-xl border-2 border-gray-300 flex justify-center items-center gap-3 hover:bg-gray-50 transition-colors"
            >
              <svg class="w-5 h-5" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <span class="font-semibold text-gray-700">Continue with Google</span>
            </button>
          </div>

        </div>
      </div>

      <!-- Footer -->
      <div class="mt-8 text-center space-y-4">
        <!-- Copyright -->
        <p class="text-sm text-gray-600 font-medium">
          © 2025 RIDC - Research and Innovation Development Center
        </p>

        <!-- Social Media Icons -->
        <div class="flex gap-3 justify-center">
          <a
            href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-[#1A4A9C] hover:border-[#1A4A9C] hover:text-white transition-all group shadow-sm hover:shadow-md"
          >
            <i
              class="fab fa-instagram text-[#03406C] text-base group-hover:text-white transition-colors"
            ></i>
          </a>
          <a
            href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-blue-400 hover:border-blue-400 hover:text-white transition-all group shadow-sm hover:shadow-md"
          >
            <i
              class="fab fa-twitter text-[#03406C] text-base group-hover:text-white transition-colors"
            ></i>
          </a>
          <a
            href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-blue-600 hover:border-blue-600 hover:text-white transition-all group shadow-sm hover:shadow-md"
          >
            <i
              class="fab fa-facebook-f text-[#03406C] text-base group-hover:text-white transition-colors"
            ></i>
          </a>
          <a
            href="#"
            class="w-10 h-10 bg-white border-2 border-blue-200 rounded-full flex items-center justify-center hover:bg-red-600 hover:border-red-600 hover:text-white transition-all group shadow-sm hover:shadow-md"
          >
            <i
              class="fab fa-youtube text-[#03406C] text-base group-hover:text-white transition-colors"
            ></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>